export default "__VITE_ASSET__BxIaKqVi__"